import dateHelper from './dateHelper'

export default {
  format (price = 0, lang = 'en') {
    price = price.toFixed(2)

    switch (lang) {
      case 'de':
        return price.replace('.', ',')
      default:
        return price
    }
  },

  getArticlePrice (priceDefault, priceNew, priceNewDate, date) {
    let result = priceDefault

    const thresholdDate = dateHelper.dateFromString(priceNewDate)
    const fromDate = dateHelper.dateFromString(date)

    if (priceNew > 0 && thresholdDate && fromDate && fromDate >= thresholdDate) {
      result = priceNew
    }

    return result
  }
}
